// import { Tokens } from '@Utilities/enum'
export default {
    namespaced: true,
    state: {
        isLoading: false,
    },
    getters: {
        isLoading: (state) => {
            return state.isLoading
        },
    },
    actions: {
        async onGetGenerics({ commit }, params) {
            try {
                commit('setIsLoading', true)
                const { date_start, date_end } = window.Subscription
                params.date_start = date_start
                params.date_end = date_end
                const response = await axios.get('/api/generic/get', { params })
                if (response && response.success) {
                    return response.data
                }

            } catch (error) {
                console.warn(error)
            }
        },

    },
    mutations: {
        setIsLoading(state, payload) {
            state.isLoading = payload
        },
    },
}
